import React, { Component } from 'react';
import PropTypes from 'prop-types';
import CustomLoader from '../common/CustomLoader';
import { drapcodeIcon } from '../../common/custom/icon-library';
import { ActionList } from '../../common/actions';
import showAlert from '../../common/utils/alert';
import TooltipInfo from '../../common/docs/TooltipInfo';
import voca from 'voca';
import { SUPABASE, DIRECTUS, APP_WRITE, XANO, ACTION, MYSQL } from 'drapcode-constant';
import { description } from '../../common/utils/event_constants';

const dropdownStyle = {
  position: 'inherit',
  transform: 'revert',
};
export class NewActionDetail extends Component {
  static propTypes = {
    actions: PropTypes.object.isRequired,
    action: PropTypes.object.isRequired,
  };

  state = {
    selectedIndex: null,
    actionFlag: false,
  };

  async componentDidMount() {
    const { projectId, actions, version } = this.props;
    if (projectId) {
      actions.loadProjectDetailEvent({ projectId, version });
    }
    const permissionData = await actions.getPermissionFlags({ projectId });
    if (permissionData && permissionData.length > 0) {
      const action = permissionData.includes(ACTION);
      this.setState({ actionFlag: action });
    }
  }

  changeSelectedIndex = (index) => {
    this.setState({ selectedIndex: index });
  };

  actionData = (action) => {
    return ActionList.find((param) => {
      return param.name === action.name;
    });
  };

  deleteAction = () => {
    const { projectId, version, selectedEvent, action, actions } = this.props;
    const text = "You won't be able to revert this.";
    const preConfirm = () => {
      actions.deleteAction({
        projectId: projectId,
        eventId: selectedEvent.uuid,
        actionId: action.uuid,
        version,
      });
    };
    const confirmButtonText = 'Yes, delete it!';
    showAlert(text, preConfirm, confirmButtonText);
  };

  displayActionLabel = (label) => {
    return label
      ? voca.truncate(label === 'Dynamic Page Redirect' ? 'Conditional Redirect' : label, 30)
      : '';
  };

  showIcon = (action) => {
    switch (action.name) {
      case 'triggerZap':
        return (
          <img
            src={require('../../common/dataSource/img/zapier.svg')}
            alt={action.label}
            className="svg svg-invert"
          />
        );
      case 'sendDataToExternalApi':
      case 'sendDataToExternalApiAndAuthorize':
      case 'sendDataToExternalApiAndFileDownload':
      case 'sendDataToExternalSource':
      case 'sendDataToExternalSourceAndFileDownload':
      case 'authorizeWithExternalDataSource':
        if (action.source && action.source === SUPABASE) {
          return (
            <img
              src={require('../../common/dataSource/img/supabase.svg')}
              alt={`${action.label}`}
              className="svg svg-invert"
            />
          );
        } else if (action.source && action.source === DIRECTUS) {
          return (
            <img
              src={require('../../common/dataSource/img/directus.svg')}
              alt={`${action.label}`}
              className="mr-3 svg"
            />
          );
        } else if (action.source && action.source === APP_WRITE) {
          return (
            <img
              src={require('../../common/dataSource/img/appwrite.svg')}
              alt={`${action.label}`}
              className="mr-3 svg"
            />
          );
        } else if (action.source && action.source === XANO) {
          return (
            <img
              src={require('../../common/dataSource/img/xano.svg')}
              alt={`${action.label}`}
              className="mr-3 svg"
            />
          );
        } else if (action.source && action.source === MYSQL) {
          return (
            <img
              src={require('../../common/dataSource/img/mysql.svg')}
              alt={`${action.label}`}
              className="mr-3 svg"
            />
          );
        } else {
          return <i className={`wb ${drapcodeIcon(action.name)}`} />;
        }
      case 'updateCellData':
        return (
          <img
            src={require('../../common/dataSource/img/Tabulator.png')}
            alt={`${action.label}`}
            className="mr-3 svg"
          />
        );
      case 'createConsentRequest':
      case 'fetchFinancialInformation':
      case 'signzyDigitalDocSign':
      case 'fetchContractDetails':
        return (
          <img
            src={require('../../common/dataSource/img/signzy.svg')}
            alt={`${action.label}`}
            className="mr-3 svg"
          />
        );
      case 'fetchGoogleCalendarEvents':
      case 'initiateGoogleCalendarAuth':
      case 'syncGoogleCalendarEvents':
      case 'scheduleGoogleCalendarEvent':
      case 'deleteGoogleCalendarEvent':
      case 'updateGoogleCalendarEvent':
        return (
          <img
            src={require('../../common/dataSource/img/google-calendar.svg')}
            alt={action.label}
            className="mr-3 svg"
          />
        );
      case 'initiateGoogleMeetAuth':
      case 'createInstantGoogleMeet':
        return (
          <img
            src={require('../../common/dataSource/img/google-meet.svg')}
            alt={action.label}
            className="mr-3 svg"
          />
        );
      case 'initiateZoomAuth':
      case 'createInstantZoomMeet':
        return (
          <img
            src={require('../../common/dataSource/img/zoom.svg')}
            alt={action.label}
            className="mr-3 svg"
          />
        );
      case 'initiateBoxAuth':
      case 'uploadFileToBox':
        return (
          <img
            src={require('../../common/dataSource/img/box.svg')}
            alt={action.label}
            className="mr-3 svg"
          />
        );
      case 'generateQR':
      case 'initiateQRCodeReader':
        return (
          <img
            src={require('../../common/dataSource/img/qr.svg')}
            alt={action.label}
            className="mr-3 svg"
          />
        );
      case 'initiateMPesaC2BPayment':
      case 'initiateMPesaB2CPayout':
      case 'registerMpesaC2BUrls':
        return (
          <img
            src={require('../../common/dataSource/img/m-pesa.svg')}
            alt={action.label}
            className="mr-3 svg"
          />
        );
      case 'metropolCreditReport':
      case 'iprsKenya':
      case 'kraPinChecker':
      case 'eStatementAnalysis':
        return (
          <img
            src={require('../../common/dataSource/img/spin-mobile.svg')}
            alt={action.label}
            className="mr-3 svg"
          />
        );
      case 'boldSignSendDocument':
      case 'boldSignDocumentStatus':
      case 'boldSignEmbeddedRequest':
        return (
          <img
            src={require('../../common/dataSource/img/boldsign.svg')}
            alt={action.label}
            className="mr-3 svg"
          />
        );
      default:
        return <i className={`wb ${drapcodeIcon(action.name)}`} />;
    }
  };

  showActionSettings = () => {
    const { action, actions } = this.props;
    const { actionFlag } = this.state;
    const actionData = this.actionData(action);
    let enableEditBtn = actionData && actionData.args !== 'undefined' && actionData.args.length > 0;

    return (
      <ul className="dropdown-menu" role="menu" aria-labelledby="dropdownMenu">
        {enableEditBtn && (
          <li key={'edit'}>
            <a
              tabIndex="-1"
              style={{ cursor: 'pointer' }}
              role={'button'}
              title="Edit Action"
              onClick={() => {
                actions.openActionPropModal(action);
              }}
            >
              <i className={`mr-3 wb ${drapcodeIcon('edit')}`}></i>
              {'Edit Action'}
            </a>
          </li>
        )}

        <li key="enable-disable">
          <a
            tabIndex="-1"
            style={{ cursor: 'pointer' }}
            role="button"
            title="Enable/Disable Action"
            onClick={() => {
              this.props.actions.openActionEnableModal(action);
            }}
          >
            <i className={`mr-3 wb ${drapcodeIcon('toggle')}`}></i>
            {'Enable/Disable Action'}
          </a>
        </li>
        <li key="delete">
          <a
            tabIndex="-1"
            className="theme-red"
            style={{ cursor: actionFlag ? 'pointer' : 'not-allowed' }}
            role="button"
            onClick={actionFlag ? this.deleteAction : undefined}
          >
            <i className={`mr-3 wb ${drapcodeIcon('delete')}`}></i>
            {'Delete Action'}
            {actionFlag ? null : (
              <>
                &nbsp;
                <TooltipInfo
                  title={description}
                  headerText={`Permission Disabled!`}
                  showHeader={true}
                  showArrow={true}
                />
              </>
            )}
          </a>
          <CustomLoader
            loading={
              this.props.selectedAction &&
              action.name === this.props.selectedAction.name &&
              this.props.showLoaderForDeleteAction
            }
          />
        </li>
      </ul>
    );
  };

  handleActionEnvToggle = (envType, isEnabled) => {
    const { action, projectId, events, actions, version } = this.props;
    const { selectedEvent } = events || '';
    const { projectDetail } = events || '';
    const { environments } = projectDetail || '';
    const envTypes = environments.map((env) => env.envType);

    const preConfirm = () => {
      if (isEnabled) {
        actions.enableAction({
          projectId: projectId,
          version: version,
          eventId: selectedEvent.uuid,
          actionId: action.uuid,
          disabledEnvironment: envType,
          envTypes,
        });
      } else {
        actions.enableAction({
          projectId: projectId,
          version: version,
          eventId: selectedEvent.uuid,
          actionId: action.uuid,
          enabledEnvironment: envType,
        });
      }
    };
    showAlert(
      `Do you want to ${isEnabled ? 'disable' : 'enable'} ${this.displayActionLabel(
        action.label,
      )} in ${voca.titleCase(envType)} Environment?`,
      preConfirm,
      `Yes, ${isEnabled ? 'Disable' : 'Enable'} it!`,
    );
  };

  renderEnvActionBtn = (actionEnv, index) => {
    const { action } = this.props;
    const { envType } = actionEnv || '';
    const { defaultEnabled, enabledEnvironments } = action || '';

    const isEnabled = defaultEnabled
      ? true
      : enabledEnvironments && enabledEnvironments.includes(envType);

    switch (envType) {
      case 'PREVIEW':
        return (
          <TooltipInfo
            title={`${isEnabled ? 'Enabled' : 'Disabled'} in ${voca.titleCase(envType)}`}
            headerText={`${isEnabled ? 'Disable' : 'Enable'} Action`}
            showHeader={false}
            showArrow={true}
            key={index + 1}
          >
            <span
              className={`badge p-1 btn btn-icon-only btn-xxs ${
                isEnabled ? 'badge-primary' : 'badge-secondary'
              }`}
              onClick={() => this.handleActionEnvToggle(envType, isEnabled)}
            >
              <i className={`wb webconnect-eye`}></i>
            </span>
          </TooltipInfo>
        );
      case 'PRODUCTION':
        return (
          <TooltipInfo
            title={`${isEnabled ? 'Enabled' : 'Disabled'} in ${voca.titleCase(envType)}`}
            headerText={`${isEnabled ? 'Disable' : 'Enable'} Action`}
            showHeader={false}
            showArrow={true}
            key={index + 1}
          >
            <span
              className={`badge p-1 btn btn-icon-only btn-xxs ${
                isEnabled ? 'badge-success' : 'badge-secondary'
              }`}
              onClick={() => this.handleActionEnvToggle(envType, isEnabled)}
            >
              <i className={`wb webconnect-paper-plane`}></i>
            </span>
          </TooltipInfo>
        );
      case 'ALPHA':
        return (
          <TooltipInfo
            title={`${isEnabled ? 'Enabled' : 'Disabled'} in ${voca.titleCase(envType)}`}
            headerText={`${isEnabled ? 'Disable' : 'Enable'} Action`}
            showHeader={false}
            showArrow={true}
            key={index + 1}
          >
            <span
              className={`badge p-1 btn btn-icon-only btn-xxs ${
                isEnabled ? 'badge-warning' : 'badge-secondary'
              }`}
              onClick={() => this.handleActionEnvToggle(envType, isEnabled)}
            >
              <i className={`wb webconnect-font`}></i>
            </span>
          </TooltipInfo>
        );
      case 'BETA':
        return (
          <TooltipInfo
            title={`${isEnabled ? 'Enabled' : 'Disabled'} in ${voca.titleCase(envType)}`}
            headerText={`${isEnabled ? 'Disable' : 'Enable'} Action`}
            showHeader={false}
            showArrow={true}
            key={index + 1}
          >
            <span
              className={`badge p-1 btn btn-icon-only btn-xxs ${
                isEnabled ? 'badge-brand-green' : 'badge-secondary'
              }`}
              onClick={() => this.handleActionEnvToggle(envType, isEnabled)}
            >
              <i className={`wb webconnect-type-bold`}></i>
            </span>
          </TooltipInfo>
        );
      default:
        return '';
    }
  };

  renderEnvBtns = () => {
    const { events } = this.props;
    const { projectDetail } = events || '';
    const { environments } = projectDetail || '';

    return (
      <div
        style={{
          marginBottom: '0px',
          marginTop: '-30px',
          position: 'absolute',
          textAlign: 'left',
          zIndex: '10',
          textAlign: 'start',
          marginLeft: '5px',
        }}
      >
        {environments &&
          environments.map((env, index) => {
            return this.renderEnvActionBtn(env, index);
          })}
      </div>
    );
  };

  render() {
    //TODO: Refactor
    const { action, draggable } = this.props;
    return (
      <>
        <div
          className="card mx-auto"
          draggable={this.props.draggable}
          onDragStart={this.props.onDragStart({
            step: this.props.action.step,
            actionId: action.uuid,
          })}
          onDragOver={this.props.onDragOver({
            step: this.props.action.step,
            actionId: action.uuid,
          })}
          onDrop={this.props.onDrop({ step: this.props.action.step, actionId: action.uuid })}
          style={{ width: 'fit-content', minWidth: '20vw' }}
        >
          <div
            style={{
              marginBottom: '0px',
              marginTop: '-5px',
              zIndex: 10,
              position: 'absolute',
              textAlign: 'start',
            }}
          >
            {action.step && (
              <span className={`badge action-step-${action.step}`}>
                {this.showIcon(action)} {`Action ${action.step}`}
              </span>
            )}
          </div>
          <div
            style={{
              marginBottom: '0px',
              marginTop: '-20px',
              zIndex: 10,
              position: 'absolute',
              textAlign: 'center',
              width: '100%',
            }}
          >
            {action.step && (
              <TooltipInfo
                title={'Hold and drag onto another action to swap steps'}
                headerText={`Rearrange Action`}
                showHeader={true}
                showArrow={true}
              >
                <button
                  className={`btn btn-fab btn-round btn-theme-default-outlined`}
                  type="button"
                  style={{
                    height: '20px',
                    minWidth: '20px',
                    width: '20px',
                    fontSize: '14px',
                    cursor: draggable ? 'pointer' : 'not-allowed',
                  }}
                >
                  <i
                    className="wb webconnect-arrows-move"
                    style={{ lineHeight: '1.8em', fontSize: '14px' }}
                  ></i>
                  <CustomLoader loading={this.props.showLoaderForSwapAction} />
                </button>
              </TooltipInfo>
            )}
          </div>
          <div className="card-content p-0">
            <table className="table">
              <tbody>
                <tr style={{ display: 'flex', justifyContent: 'space-around' }}>
                  <td colSpan="1"></td>
                  <td colSpan="2" className="w-90 border-right-1" style={{ alignSelf: 'center' }}>
                    <h6
                      className="avatar__title"
                      title={action.label}
                      style={{ textTransform: 'revert' }}
                    >
                      {this.displayActionLabel(action.label)}
                    </h6>
                  </td>
                  <td colSpan="1" className="px-0" style={{ alignSelf: 'center' }}>
                    <div className="cb settings" title="Action Settings" style={dropdownStyle}>
                      <div className="dropdown">
                        <a
                          id="dropdown-action-settings"
                          role="button"
                          data-toggle="dropdown"
                          onClick={() => this.changeSelectedIndex(0)}
                          title="Action Settings"
                        >
                          <i className="wb webconnect-cog" style={{ verticalAlign: '-0.6em' }}></i>
                        </a>
                        {this.showActionSettings()}
                      </div>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          {this.renderEnvBtns()}
        </div>
      </>
    );
  }
}
